const blobToFile = (blob, fileName, when = new Date()) => {
  blob.lastModifiedDate = when
  blob.name = fileName
  return blob
}

export default blobToFile
